import React from 'react';
import classNames from 'classnames';
const lodashUtil = require('lodash/util');

class SelfTestOption extends React.Component {
  state = {
    isValid: false === this.props.IsCorrect,
    checked: false,
  };
  id = lodashUtil.uniqueId('option-');


  isValid(e) {
    this.setState({
      isValid: e.currentTarget.checked === this.props.IsCorrect,
      checked: e.currentTarget.checked,
    });
  }

  resetOption() {
    this.setState({
      isValid: false === this.props.IsCorrect,
      checked: false,
    });
  }

  componentDidMount() {
    this.props.addOptionToValidation(this);
  }
  

  render() {
    const classes = classNames({
      'c-self-test__label': true,
      'c-self-test__label__checked': this.state.checked,
    });
    const id = this.id;
    return (
      <label className={classes} htmlFor={id}>
        <input
          onChange={(e) => this.isValid(e)}
          checked={this.state.checked}
          type="checkbox"
          className="c-self-test__checkbox"
          id={id}
        />
        <span className="c-self-test__option-text">
          {this.props.AnswerText}
        </span>
      </label>
    );
  }
}

export default SelfTestOption;
